


import React, { useState, useEffect } from 'react';
import '../../App.css';
import { companyService } from '../../api/apiService';

function AddCompany() {
  const [companyName, setCompanyName] = useState('');
  const [companyAddress, setCompanyAddress] = useState('');
  const [companyEmail, setCompanyEmail] = useState('');
  const [companyPhone, setCompanyPhone] = useState('');
  const [companies, setCompanies] = useState([]);

  // Fetch companies when component mounts and reloads
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await companyService.getAllCompanies(1, 1000); // Fetch all companies
        const companiesData = response?.data?.companies || response?.data || [];
        setCompanies(companiesData);
      } catch (error) {
        console.error('Error fetching companies:', error);
        alert('Error loading companies');
      }
    };

    fetchCompanies();
  }, []);

  const deleteCompany = async (company) => {
    if (!window.confirm(`Delete "${company.name}"? This cannot be undone.`)) return;
    try {
      await companyService.deleteCompany(company.id);
      setCompanies(prev => prev.filter(c => c.id !== company.id));
    } catch (error) {
      console.error('Error deleting company:', error);
      alert('Error deleting company: ' + (error.response?.data?.message || error.message));
    }
  };

  const addCompany = async (e) => {
    e.preventDefault();
    try {
      const companyData = {
        name: companyName,
        address: companyAddress,
        email: companyEmail,
        phone_number: companyPhone
      };

      const response = await companyService.createCompany(companyData);
      // console.log("Company added successfully:", response);
      alert("Company added successfully");

      // Reset input fields
      setCompanyName('');
      setCompanyAddress('');
      setCompanyEmail('');
      setCompanyPhone('');

      // Reload the list of companies by fetching fresh data
      const updatedResponse = await companyService.getAllCompanies(1, 1000);
      const updatedCompaniesData = updatedResponse?.data?.companies || updatedResponse?.data || [];
      setCompanies(updatedCompaniesData);
    } catch (error) {
      console.error("Error adding company:", error);
      alert("Error adding company: " + (error.response?.data?.message || error.message));
    }
  }

  return (
    <div className="content-wrapper page">
      <div className="content-wrapper">
        <h1>Add New Company</h1>
        <div style={{ marginTop: '30px', marginBottom: '80px' }}>
          <form onSubmit={addCompany}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              width: '400px',
            }}>
            <input className='inputtext' type="text" value={companyName} onChange={(e) => setCompanyName(e.target.value)} required placeholder='Company Name'/>
            <input className='inputtext' type="text" value={companyAddress} onChange={(e) => setCompanyAddress(e.target.value)}  placeholder='Company Address'/>
            <input className='inputtext' type="text" value={companyEmail} onChange={(e) => setCompanyEmail(e.target.value)}  placeholder='Company Email'/>
            <input className='inputtext' type="text" value={companyPhone} onChange={(e) => setCompanyPhone(e.target.value)}  placeholder='Company Phone Number'/>
            <div className='button-wrapper'>
              <button style={{ marginTop: '10px' }} className='big-button' type="submit">Add Company</button>
            </div>
          </form>
        </div>
        </div>

        {/* List of companies */}
        <div className='content-wrapper'>
          <h2 style={{ marginBottom: '50px' }} className='h2'>List of Companies</h2>
        </div>
        <div className='content-wrapper content-wrapper-talent-list'>
          <div className='list-tasks-header'>
            <div style={{ flexBasis: '500px' }} >Name</div>
            <div style={{ flexBasis: '200px' }} >Email</div>
            <div style={{ flexBasis: '300px' }} >Address</div>
            <div style={{ flexBasis: '300px' }} >Phone</div>
            <div style={{ flexBasis: '100px' }} ></div>
          </div>

          {companies.map(company => (
            <div key={company.id} className='list-tasks-item'>
              <div style={{ flexBasis: '500px' }} >{company.name}</div>
              <div style={{ flexBasis: '200px' }} >{company.email}</div>
              <div style={{ flexBasis: '300px' }} >{company.address}</div>
              <div style={{ flexBasis: '300px' }} >{company.phone_number || company.phone}</div>
              <div style={{ flexBasis: '100px' }} >
                <button
                  type="button"
                  className="button button-red"
                  style={{ padding: '6px 12px', fontSize: '0.75rem' }}
                  onClick={() => deleteCompany(company)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
    </div>
  );
}

export default AddCompany;
